import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { pages } from './constants';
const routes: Routes = [
  {
    path: '',
    redirectTo: pages.home,
    pathMatch: 'full'
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./pages/folder/folder.module').then( m => m.FolderPageModule)
  },
  {
    path: pages.onboarding,
    loadChildren: () => import('./pages/onboarding/onboarding.module').then( m => m.OnboardingPageModule)
  },
  {
    path: pages.login,
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: pages.forgotpassword,
    loadChildren: () => import('./pages/forgotpassword/forgotpassword.module').then( m => m.ForgotpasswordPageModule)
  },
  {
    path: pages.signup,
    loadChildren: () => import('./pages/signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: pages.otp,
    loadChildren: () => import('./pages/otp/otp.module').then( m => m.OtpPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: pages.home,
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: pages.homeitem,
    loadChildren: () => import('./pages/homeitem/homeitem.module').then( m => m.HomeitemPageModule)
  },
  {
    path: pages.products,
    loadChildren: () => import('./pages/products/products.module').then( m => m.ProductsPageModule)
  },
  {
    path: pages.productdetail,
    loadChildren: () => import('./pages/productdetail/productdetail.module').then( m => m.ProductdetailPageModule)
  },
  {
    path: pages.wishlist,
    loadChildren: () => import('./pages/wishlist/wishlist.module').then( m => m.WishlistPageModule)
  },
  {
    path: pages.search,
    loadChildren: () => import('./pages/search/search.module').then( m => m.SearchPageModule)
  },
  {
    path: pages.cart,
    loadChildren: () => import('./pages/cart/cart.module').then( m => m.CartPageModule)
  },
  {
    path: pages.address,
    loadChildren: () => import('./pages/address/address.module').then( m => m.AddressPageModule)
  },
  {
    path: pages.payment,
    loadChildren: () => import('./pages/payment/payment.module').then( m => m.PaymentPageModule)
  },
  {
    path: pages.summary,
    loadChildren: () => import('./pages/summary/summary.module').then( m => m.SummaryPageModule)
  },
  {
    path: pages.successmodal,
    loadChildren: () => import('./pages/successmodal/successmodal.module').then( m => m.SuccessmodalPageModule)
  },
  {
    path: pages.notifications,
    loadChildren: () => import('./pages/notifications/notifications.module').then( m => m.NotificationsPageModule)
  },
  {
    path: pages.myorders,
    loadChildren: () => import('./pages/myorders/myorders.module').then( m => m.MyordersPageModule)
  },
  {
    path: pages.orderdetails,
    loadChildren: () => import('./pages/orderdetails/orderdetails.module').then( m => m.OrderdetailsPageModule)
  },
  {
    path: pages.addreview,
    loadChildren: () => import('./pages/addreview/addreview.module').then( m => m.AddreviewPageModule)
  },
  {
    path: pages.settings,
    loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: pages.profile,
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: pages.signout,
    loadChildren: () => import('./pages/signout/signout.module').then( m => m.SignoutPageModule)
  },
  {
    path: pages.useraddress,
    loadChildren: () => import('./pages/useraddress/useraddress.module').then( m => m.UseraddressPageModule)
  },
  {
    path: pages.preferencias,
    loadChildren: () => import('./pages/preferencias/preferencias.module').then( m => m.PreferenciasPageModule)
  },
  {
    path: pages.typedelivery,
    loadChildren: () => import('./pages/typedelivery/typedelivery.module').then( m => m.TypedeliveryPageModule)
  },
  {
    path: pages.ordendetailsproducts,
    loadChildren: () => import('./pages/ordendetailsproducts/ordendetailsproducts.module').then( m => m.OrdendetailsproductsPageModule)
  },
  {
    path: pages.editprofile,
    loadChildren: () => import('./pages/editprofile/editprofile.module').then( m => m.EditprofilePageModule)
  },
  {
    path: pages.errors,
    loadChildren: () => import('./pages/errors/errors.module').then( m => m.ErrorsPageModule)
  },
  {
    path: '**',
    redirectTo: pages.home
  },
  {
    path: 'homeitem',
    loadChildren: () => import('./pages/homeitem/homeitem.module').then( m => m.HomeitemPageModule)
  },  {
    path: 'demo',
    loadChildren: () => import('./pages/demo/demo.module').then( m => m.DemoPageModule)
  }




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule {}
